import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiConfig } from '../Config/api.config';
@Injectable({
  providedIn: 'root'
})
export class ContactElectricityMeterService {

  constructor(private http: HttpClient) {}

  postElectricityMeter(userSession: string, contactId: string, meterName: string, meterNumber: string, requestType: string): Observable<any> {
    const headers = new HttpHeaders({
      'X-Api-Key': ApiConfig.apiKey,
      'Authorization': `Bearer ${userSession}`
    });

    const request = {
      contactId,
      meterName,
      meterNumber,
      requestType
    };
    return this.http.post(
      `${ApiConfig.baseUrl}/ContactElectricityMeter/add-meter`,
      request,
      {
        headers
      }
    );
  }
}